import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import InvitationFromImage from '../../TableAdmin/MyGuests/MyGuestsExcel/InvitationFromImageShere';
import { obtenAcompanantes, infoInvitation, putInvitationGuestStatus } from 'services/rsvp/getRSVP';
import "./format.css";
import baby from 'assets/img/baby.svg';
import adulto from 'assets/img/adulto.png';
import arrowB from 'assets/img/arrowB.png';

const Invitation = () => {
    const [paso, setPaso] = useState(1);
    const [servicioAcompanantes, setServicioAcompanantes] = useState('');
    const [infoInvitados, setInfoInvitados] = useState('');
    const [jsonResultado, setJsonResultado] = useState(null);
    const { tableId } = useParams();
    const { guestId } = useParams();
    const [idAcompanante, setIdAcompanante] = useState([]);
    const [shareUrl, setShareUrl] = useState('');
    const [confirmInvitation, setConfirmInvitation] = useState(true);

    //console.log('servicioAcompanantes',servicioAcompanantes);

    function limpiarYFormatearURL(url) {
        // Reemplaza espacios con guiones
        url = url.replace(/\s+/g, '-');

        // Elimina caracteres especiales (excepto guiones y letras)
        url = url.replace(/[^a-zA-Z0-9-/]/g, '');

        // Convierte a minúsculas
        url = url.toLowerCase();

        // Elimina guiones duplicados
        url = url.replace(/-{2,}/g, '-');

        return url;
    }

    const lineaEstilos = {
        width: '60%',
        height: '2px',
        backgroundColor: '#a29999',
        margin: '0 auto',
    };

    const handleGiftsTable = () => {
        window.location.href = shareUrl;
    };

    const handleConfirmAssistance = () => {
        setPaso(2);
    };

    const handleAssistance = (confirm) => {
        const companions = confirm ? idAcompanante : null;
        const invitation_status = confirm ? 2 : 3;
        const nuevoRegistro = {
            invitation_status,
            companions
        };

        console.log('nuevoRegistro', nuevoRegistro);
        // Actualizar el estado del resultado JSON
        setJsonResultado(nuevoRegistro);
    };

    const handleCheckboxChange = (id) => {
        if (!idAcompanante.includes(id)) {
            setIdAcompanante([...idAcompanante, id]);
        } else {
            const updatedArray = idAcompanante.filter((acompananteId) => acompananteId !== id);
            setIdAcompanante(updatedArray);
        }
    };

    const icono = (age) => {
        if(age === 'adulto') return <img style={{ height: '80%', width: '80%', objectFit: 'cover' }} src={adulto} />
        if(age === 'niño') return <img style={{ height: '100%', width: '100%', objectFit: 'cover' }} src={baby} />
        if(age === 'bebe') return <img style={{ height: '100%', width: '100%', objectFit: 'cover' }} src={baby} />
    };

    const evento_fecha = (fecha) => {
        const fecha_evento = new Date(fecha);
        const opcionesMes = { month: 'long' };
        const nombreMes = new Intl.DateTimeFormat('es-ES', opcionesMes).format(fecha_evento);
        const primeraLetraMayuscula = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);
        const dia = fecha_evento.getDate();
        const año = fecha_evento.getFullYear();
        const fechaFormateada = `${dia} · ${primeraLetraMayuscula} · ${año}`;
        return fechaFormateada;
    };


    console.log('shareUrl', shareUrl);
    console.log('idAcompanante', idAcompanante)
    //console.log('opcionSeleccionada es: ',opcionSeleccionada);
    console.log('confirmInvitation', confirmInvitation);
    useEffect(() => {
        //      CONSUMIR API PARA OBTENER LA INVITACION
        console.log('tableId es:', tableId);
        console.log('guestId es:', guestId);

        !guestId && setConfirmInvitation(false);


        //          OBTENER ACOMPAÑANTES 
        obtenAcompanantes(guestId).then((valorDeServicio) => {
            console.log('obtenAcompanantes ', valorDeServicio);

            // Valida la respuesta del backend
            if (valorDeServicio?.metadata?.http_status == 200) {
                console.log('invitation_status', valorDeServicio?.data);
                console.log('invitation_status redirect', shareUrl);

                

                if (valorDeServicio?.data?.invitation_status === 'pendiente' || valorDeServicio?.data?.invitation_status === 'sin estatus') {
                    setServicioAcompanantes(valorDeServicio?.data?.items);
                    infoInvitation(tableId).then((valorDeServicio) => {
                        console.log('infoInvitation en padre', valorDeServicio);
                        if (valorDeServicio?.metadata?.http_status !== 404) {
                            setInfoInvitados(valorDeServicio?.data);
                            console.log('valorDeServicio?.data', valorDeServicio?.data);
                            setShareUrl(window.location.origin + '/Mesa-de-Regalos/' + limpiarYFormatearURL(tableId + '/' + valorDeServicio?.data?.name));
                        }
                    });
                } else {
                    alert('Ya confirmaste tu asistencia');
                    window.location.href = window.location.origin + '/Mesa-de-Regalos/' + limpiarYFormatearURL(tableId + '/mesa-regalos');
                }
            }else{
                if(guestId){
                    alert('No estas invitado a este evento');
                    window.location.href = window.location.origin + '/Mesa-de-Regalos/' + limpiarYFormatearURL(tableId + '/mesa-regalos');
                }
            }
        });
    }, []);

    useEffect(() => {
        if (jsonResultado !== null) {
            //alert('JsonResultado ' + JSON.stringify(jsonResultado, null, 2));           // Eliminar

            putInvitationGuestStatus(guestId, jsonResultado).then((valorDeServicio) => {
                console.log('putInvitationGuestStatus', valorDeServicio);
                if (valorDeServicio?.metadata?.http_status !== 404) {
                    //alert('Estatus actualizado correctamente');
                    setPaso(3);
                } else {
                    alert('Error al confirmar la asistencia');
                    setPaso(1);
                }
            });
        }
    }, [jsonResultado]);
    console.log('infoInvitados', infoInvitados);

    return (
        <>
            <div className="mi-div">
                <img src={"https://www.sears.com.mx/img/logo_blc.svg"} />
            </div>
            {paso === 1 && (
                <div className="d-flex flex-column align-items-center">
                    <div className='col-md-4 col-sm-6 mb-3'>
                        <InvitationFromImage imgInvitation={infoInvitados?.template_url} typeIdFather={tableId} idReturn={1}/>
                        {confirmInvitation ? <><br /><br /><br /><br /><br /></> : <><br /><br /><br/></>}
                    </div>
                    <div className='col-md-3 col-sm-6 d-flex flex-column align-items-center mt-5'>
                        {confirmInvitation && (
                            <div style={{ marginBottom: '1rem' }}>
                                <Button
                                id={4}
                                block
                                variant="secundary"
                                onClick={handleConfirmAssistance}
                                type="button"
                                className={'mb-3'}
                                >
                                    Confirmar asistencia
                                </Button>
                            </div>
                        )}
                        <div>
                            <Button
                                id={4}
                                block
                                variant="primary"
                                onClick={handleGiftsTable}
                                type="button"
                                className={'mb-3'}
                            >
                                Ver mi mesa de regalos
                            </Button>
                        </div>
                    </div>
                </div>
            )}
            {paso === 2 && (
                <div className="container mx-auto my-5 card mb-3 shadow-lg" style={{ maxWidth: '950px', boxShadow: '0px 0px 10px 0px #ccc' }}>
                    <h1 className="card-title" style={{ textAlign: 'left', paddingBlock: '40px' }}>CONFIRMA TU ASISTENCIA</h1>
                    <div className="row g-0">
                        <div className="col-md-4">
                            <img src={infoInvitados?.image_mobile} alt="" className="img-fluid rounded-start" style={{ width: '100%' }} />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h5 className="card-title">{infoInvitados?.event_name}</h5>
                                <div style={lineaEstilos}></div>
                                <div class="contenedorDate">
                                    <p className="card-text">{evento_fecha(infoInvitados?.event_date)}</p>
                                </div>
                                <center>
                                {servicioAcompanantes.length > 0 && (
                                    <div class="contenedorInfo">
                                        <table class="contenedorTable">
                                            {servicioAcompanantes.length >= 0 && (
                                                <tr>
                                                    <th colspan="3" style={{ textAlign: 'left' }}>Confirma tus acompañantes:</th>
                                                    <th colspan="1"><img style={{ height: '50%', width: '50%'}} src={arrowB}/></th>
                                                </tr>
                                            )}
                                            {servicioAcompanantes.length >= 0 && (
                                                servicioAcompanantes.map((acompanante) => (
                                                    <tr class="trInfo" key={acompanante.id}>
                                                        <td>
                                                            <center>
                                                                <div style={{
                                                                    borderRadius: '50%',
                                                                    overflow: 'hidden',
                                                                    height: '35px',
                                                                    width: '35px',
                                                                    border: '2px solid #a29999',
                                                                }}>
                                                                    {icono(acompanante.age)}
                                                                </div>
                                                            </center>
                                                        </td>
                                                        <td style={{ textAlign: 'left' }}>{acompanante.name} {acompanante.last_name}</td>
                                                        <td style={{ textAlign: 'left' }}>{acompanante.age}</td>
                                                        <td>
                                                            <center>
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-${acompanante.id}`}
                                                                onChange={() => handleCheckboxChange(acompanante.id)}
                                                                class="myInputRed"
                                                            />
                                                            </center>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </table>
                                    </div>
                                )}
                                </center>
                                <div className="d-flex justify-content-between my-3">
                                    <Button
                                        id={41}
                                        variant="primary"
                                        onClick={() => handleAssistance(1)}
                                        type="button"
                                        className={'btn-sm col-md-5'}>
                                        Si asistiré
                                    </Button>
                                    <Button
                                        id={42}
                                        variant="secundary"
                                        onClick={() => handleAssistance(0)}
                                        type="button"
                                        className={'btn-sm col-md-5'}>
                                        No asistiré
                                    </Button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}

            {paso === 3 && (
                <div className="container mx-auto my-5 card mb-3 shadow-lg" style={{ maxWidth: '800px', boxShadow: '0px 0px 10px 0px #ccc' }}>
                    <h1 className="card-title text-left" style={{ paddingBlock: '40px' }}>
                        CONFIRMA TU ASISTENCIA
                    </h1>
                    <div className="row g-0">
                        <div className="col-md-4">
                            <img src={infoInvitados?.image_mobile} alt="" className="img-fluid rounded-start" style={{ width: '100%' }} />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h5 className="card-title">{infoInvitados?.event_name}</h5>
                                <hr />
                                <p className="card-text">{evento_fecha(infoInvitados?.event_date)}</p>
                                <p className="card-text">¡Gracias por confirmar tu asistencia!</p>
                                <Button
                                    id={41}
                                    variant="primary"
                                    onClick={handleGiftsTable}
                                    type="button"
                                    className={'mb-3'}
                                >
                                    Ir a su mesa de regalos
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Invitation;